import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { masterDataInitialState } from "./initialState";
import { MasterDataResponse } from "../../../types/api-response";

const masterDataSlice = createSlice({
  name: "master",
  initialState: () => {
    const initialState = { ...masterDataInitialState };
    return initialState;
  },
  reducers: {
    fetchDataSuccess: (state, action: PayloadAction<MasterDataResponse>) => {
      return {...action.payload };
    },
  },
});

export const { fetchDataSuccess } = masterDataSlice.actions;

export default masterDataSlice;
